import React from 'react';
import PropTypes from 'prop-types';
import {
  ImageContainer,
  ImageWrapper,
  ItemNumber,
  ItemTopSection,
  StyledImage,
  Wrapper
} from './SceneListItem.styled';

const SceneListItem = ({ scene }) => {
  return (
    <Wrapper>
      <ItemTopSection data-testid="scene-item-header">
        <ItemNumber>{scene.position}</ItemNumber>
      </ItemTopSection>
      <ImageContainer>
        <ImageWrapper>
          {scene.thumbnail && (
            <StyledImage
              src={scene.thumbnail}
              alt={`Scene ${scene.position} thumbnail`}
            />
          )}
        </ImageWrapper>
      </ImageContainer>
    </Wrapper>
  );
};

SceneListItem.propTypes = {
  scene: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired
  })
};

export default SceneListItem;
